"use client";
import { useEffect, useRef } from "react";

import { SERVER_PHASE } from "@stadium/constants";
import {
  ZENDESK_CHAT_WIDGET_SELECTOR,
  ZENDESK_POSITION_BOTTOM_DEFAULT,
} from "@stadium/services/zendesk/constants";

const getZendeskElement = () => {
  return typeof document !== "undefined" && document.querySelector(ZENDESK_CHAT_WIDGET_SELECTOR);
};

const ZendeskIconPositionAdjuster = ({
  bottomOffset = ZENDESK_POSITION_BOTTOM_DEFAULT,
  adjustOnUnmount = true,
  children,
}) => {
  const isZeLoaded = !SERVER_PHASE && typeof window.zE !== "undefined";

  const ref = useRef(null);
  ref.current = getZendeskElement();

  const currentPosition = ref.current?.style?.bottom || ZENDESK_POSITION_BOTTOM_DEFAULT;

  const setOrScheduleBottomOffsetPlacement = (intervalId) => {
    if (isZeLoaded && ref.current) {
      ref.current.style.bottom = bottomOffset;
      if (intervalId) {
        clearInterval(intervalId);
      }
    }
  };

  useEffect(() => {
    if (isZeLoaded) {
      const id = setInterval(() => {
        setOrScheduleBottomOffsetPlacement(id);
      }, 200);
    }
    return () => {
      if (ref.current && adjustOnUnmount) ref.current.style.bottom = currentPosition;
    };
  }, [isZeLoaded]);

  return children;
};
export default ZendeskIconPositionAdjuster;
